import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchUserDashboard } from '../../../../api/userDashboardApi';
import '../TrainingMockExamSection.css';

const Mock = () => {
  const [mockData, setMockData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const fetchDashboard = async () => {
      try {
        const dashboard = await fetchUserDashboard(userId);
        setMockData(dashboard?.mock || []);
      } catch (error) {
        // console.error('Error fetching dashboard data:', error);
        setMockData([]); 
      } finally {
        setLoading(false); 
      }
    };

    fetchDashboard();
  }, []);

  return (
    <div className="mock-exam-container">
      <h2 className='heading-for-dashboard-user' style={{ textAlign: 'start' }}>📝 Mock</h2>
      {loading ? (
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      ) : mockData.length === 0 ? (
        <div className="spinner-container">
          <div className="no-data-user-dashboard">No Mock Assigned!</div>
        </div>
      ) : (
        <div className="training-container">
          {mockData.map((mock) => (
            <div className="insurance-card" key={mock.examId}>
              <div className="card-header">
                <h2>{mock.examName}</h2>
                <div className="category">
                  <Link to={`/user/startexam/${mock.examId}`}>
                    <button className="go-to-training-btn">Go to Mock</button>
                  </Link>
                </div>
              </div>
              <div className="policy-details">
                <div className="detail-row">
                  <span className="label">Number of Questions:</span>
                  <span className="value">{mock.numberOfQuestions}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Duration (mins):</span>
                  <span className="value">{mock.durationMinutes}</span>
                </div>
                
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Mock;
